import React, {Component} from 'react';

import styles from '../../../static/css/componentStyleModules/inputComponentStyleModules/thanksSortInput.module.scss';

//controller
import ThanksControllerAPI from '../../../controllers/API/ThanksControllerAPI.js';
import MemberControllerAPI from '../../../controllers/API/MemberControllerAPI.js';

import InlineRadio from './InlineRadio.js';
import FaceIconBaseComponent from '../../faceIconComponents/FaceIconBaseComponent';

export default class ThanksSortInputComponent extends Component {

    constructor(props){
        super(props);
        this.state = {
            yearList:[],
            monthList:[0,'01','02','03','04','05','06','07','08','09','10','11','12'],
            members:[],
        }
    }

    componentWillMount(){
        //yearListを整備        
        ThanksControllerAPI.index('yearList')
        .then((result) => {
            result.data.unshift(0);
            this.setState({yearList:result.data});
        }).catch((error) => {
            console.log(error.message);
        })
        
        //member情報を取得
        MemberControllerAPI.index()
        .then((result) => {
            const allMemberObj = {
                id:0,
                name:'みんな',
                head:'basic',
                eyes:'basic',
                eysblows:'none',
                mouth:'basic',
                color:'hsl(6,77%,62%)'
            }

            const nullMemberObj = {
                id:null,
                name:'ななしさん',
                head:'basic',
                eyes:'basic',
                eysblows:'none',
                mouth:'basic',
                color:'#888888'
            }

            result.data.unshift(allMemberObj);
            result.data.push(nullMemberObj);
            this.setState({members:result.data});
        })
        .catch(function(error){
            console.log(error.message);
        });

    }

    componentDidMount = () => {
        process.nextTick(() => {
            this.refs.thanksSortInputArea.classList.remove(styles['hidden']);
        })
    }

    changeYearRadio = (value) => {
        this.props.onYearValueChange(value);
    }

    changeMonthRadio = (value) => {
        this.props.onMonthValueChange(value);
    }

    changeMemberRadio = (id,name) => {
        this.props.onMemberIdChange(id,name);
    }

    changeThanksRadio = (value) => {
        this.props.onThanksCheckValueChange(value)
    }

    sortStart = () => {
        this.props.onOkButtonClick();
    }

    cancel = () => {
        this.props.onCancelButtonClick();
    }

    render() {

        const memberGrid = (member) => {

            let memberGridClass = 
                this.props.memberSortId === member.id 
                ? styles['memberGrid'] + ' ' + styles['checked'] 
                : styles['memberGrid'];

            return(
                <div className={memberGridClass} key={member.id}
                onClick={() => this.changeMemberRadio(member.id,member.name)}>
                  <div className={styles['memberIcon']}>
                    <FaceIconBaseComponent
                    head={member.head}
                    eyes={member.eyes}
                    eyeblows={member.eyeblows}
                    mouth={member.mouth}
                    fillColor={member.color} />
                  </div>
                  <div className={styles['memberName']}>
                    {member.name}
                  </div>
                </div>
            )
        }

        const thanksCheckRadioButtonList = [
            {display:'すべて',value:'all'},
            {display:'あり',value:'checked'},
            {display:'なし',value:'unchecked'},
        ]

        return (
            <div className={styles['thanksSortInputArea'] + ' ' + styles['hidden']}
            ref="thanksSortInputArea">
              <div className={styles['submitButtonArea']}>
                <div className="touchActiveDark"
                onClick={() => this.cancel()}>キャンセル</div>
                <div className="touchActiveDark"
                onClick={() => this.sortStart()}>OK</div>
              </div>

              <div className={styles['inputArea']}>
                <div className={styles['dateSelectArea']}>
                  <h2>いつ？</h2>
                  <div className={styles['dateSelectWindowArea']}>
                    <div className={styles['yearSelectArea']}>
                      {this.state.yearList.map((year) => {
                          return (
                              <li key={year}
                              className={this.props.yearSortValue === year ? styles['checked'] : ''}
                              onClick={() => this.changeYearRadio(year)}>
                                {year === 0 ? 'すべて' : year + '年'}
                              </li>
                          )
                      })}
                    </div>
                    <div className={styles['monthSelectArea']}>
                      {this.state.monthList.map((month) => {
                          return (
                              <li key={month}
                              className={this.props.monthSortValue === month ? styles['checked'] : ''}
                              onClick={() => this.changeMonthRadio(month)}>
                                {month === 0 ? 'すべて' : month + '月'}
                              </li>
                          )
                      })}
                    </div>
                  </div>
                </div>

                <div className={styles['memberSelectArea']}>
                  <h2>だれの？</h2>
                  <div className={styles['memberSelectWindow']}>
                    {this.state.members.map(memberGrid)}
                  </div>
                </div>

                <div className={styles['thanksCheckSelectArea']}>
                  <h2>ありがとチェック</h2>
                  <div className={styles['radioArea']}>
                    <InlineRadio
                    buttonList={thanksCheckRadioButtonList}
                    value={this.props.thanksCheckSortValue}
                    onRadioClick={this.changeThanksRadio}
                    color="hsl(6,77%,62%)"
                    />
                  </div>
                </div>
              </div>
            </div>
        )
    }

};

